const TextUtil = {
    isEmpty: (text) => {
        return !text || text === undefined || text === '' || text === null
    }
}

export default TextUtil;